/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Minecraft-style username`)
};

const zh_hans1_settings_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的 Minecraft 风格用户名`)
};

const zh_hant1_settings_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的 Minecraft 風格使用者名稱`)
};

const fr_settings_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre pseudo style Minecraft`)
};

const de_settings_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Minecraft-Style Benutzername`)
};

const ja_settings_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 風のユーザー名`)
};

const ko_settings_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 스타일 사용자 이름`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_username_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_username_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_username_placeholder", locale)
	if (locale === "en") return en_settings_username_placeholder(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_username_placeholder(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_username_placeholder(inputs)
	if (locale === "fr") return fr_settings_username_placeholder(inputs)
	if (locale === "de") return de_settings_username_placeholder(inputs)
	if (locale === "ja") return ja_settings_username_placeholder(inputs)
	return ko_settings_username_placeholder(inputs)
};